import { render, staticRenderFns } from "./NewMessengerConversationDetailsOrder.vue?vue&type=template&id=63e1650a&scoped=true"
import script from "./NewMessengerConversationDetailsOrder.vue?vue&type=script&lang=js"
export * from "./NewMessengerConversationDetailsOrder.vue?vue&type=script&lang=js"
import style0 from "./NewMessengerConversationDetailsOrder.vue?vue&type=style&index=0&id=63e1650a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e1650a",
  null
  
)

export default component.exports